import React, { useState } from "react";
import { QqControlPropsType } from "./qq-control-props.type";
import { CheckboxControlSettingsModel } from "../model/checkbox-control.settings.model";
import { OptionValueModel } from "../model/option-value.model";
import { checkboxAction } from "../message-interop/control-actions/checkbox.action";

export const QqCheckboxControlRaw: React.FunctionComponent<
  QqControlPropsType<CheckboxControlSettingsModel, OptionValueModel>
> = ({ qq, settings, dispatch }) => {
  const [checked, setChecked] = useState<boolean>(
    settings.default === "checked"
  );

  if (qq.visible !== undefined && !qq.visible) return <span />;
  const checkedProps = checked ? { checked: true } : {};

  return (
    <div>
      <input
        type="checkbox"
        id={qq.key}
        name={qq.key}
        {...checkedProps}
        onChange={(e) => {
          setChecked(checked);
          dispatch(checkboxAction(qq, e.target.checked));
        }}
      />
      <label htmlFor={qq.key}>{qq.text}</label>
    </div>
  );
};
